// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionTenantSetup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import connect from 'share/enhancers/Izenda.Connect';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import Input from 'share/components/controls/Izenda.Input';
import actions from '../Izenda.PermissionActions';
import { SECTION } from 'logic/data/Izenda.PermissionConstants';
import EventsUtils from 'EventUtils';
import uiState from 'logic/Izenda.UiState.js';
import CheckboxAllPermission from './Izenda.CheckboxAllPermission';
import SettingConstant from 'logic/data/Izenda.SettingConstants';
import { isNil, get } from 'lodash/fp';

@connect(actions)
export default class PermissionTenantSetup extends Component {
  static propTypes = {
    permission: PropTypes.object.isRequired
  };

  componentWillMount() {
    const notifyChange = EventsUtils.notifyChange;
    const { permission } = this.props;
    this.tenantSetup = this.props.permission.tenantSetup;

    this.onChangeCreate = notifyChange(
      permission.updateData.bind(permission, this.tenantSetup.actions, 'create'),
      EventsUtils.CHECKBOX
    );
    this.onChangeEdit = notifyChange(
      permission.updateData.bind(permission, this.tenantSetup.actions, 'edit'),
      EventsUtils.CHECKBOX
    );
    this.onChangeDel = notifyChange(
      permission.updateData.bind(permission, this.tenantSetup.actions, 'del'),
      EventsUtils.CHECKBOX
    );
    this.onChangePermission = notifyChange(
      permission.updateData.bind(permission, this.tenantSetup.permissions, 'value'),
      EventsUtils.CHECKBOX
    );
  }

  render() {
    const { isTemplatePermissions, permissionStore, permission, localization, tenantDetail } = this.props;
    const tenantSetup = get('tenantSetup', tenantDetail);
    const isSingleMode = uiState.systemMode === SettingConstant.SYSTEM_MODE;

    return (
      isNil(uiState.getTenantId()) &&
      !permission.isTenantSetup &&
      !isSingleMode && (
        <div className={SECTION.TenantSetup}>
          <GridLayout className='izenda-GridLayout-Custom'>
            <GridLayout.Row className='u_textBold u_paddingTop u_paddingBottom izenda-PermissionCategory-Header'>
              <GridLayout.Col cols={2}>
                <a
                  className={this.props.getIconClass('isShowTenantSetup')}
                  onClick={this.props.toggle.bind(this, 'isShowTenantSetup')}
                />
                {localization.getText('COMMON_LABEL_TENANT_SETUP')}
              </GridLayout.Col>
              <GridLayout.Col cols={9}>
                <CheckboxAllPermission
                  permission={permission}
                  readOnly={this.props.readOnly}
                  disabled={isTemplatePermissions}
                  section={this.tenantSetup}
                  tenantPermission={tenantSetup}
                  tenantDetail={tenantDetail}
                />
              </GridLayout.Col>
            </GridLayout.Row>
          </GridLayout>
          {permissionStore.isShowTenantSetup && (
            <GridLayout className='izenda-GridLayout-Custom'>
              <GridLayout.Row className='u_paddingTop u_paddingBottom'>
                <GridLayout.Col cols={2} className='izenda-PermissionCategory-SubCategory'>
                  {localization.getText('COMMON_LABEL_ACTIONS')}
                </GridLayout.Col>
                <GridLayout.Col cols={9}>
                  <div className='u_inlineBlock izenda-PermissionCategory-group_left'>
                    <label>
                      <Input
                        type='checkbox'
                        checked={this.props.getCheckedCommon(this.tenantSetup.actions.create)}
                        onChange={this.onChangeCreate}
                        disabled={isTemplatePermissions}
                      />
                      <span>{localization.getText('COMMON_LABEL_CREATE')}</span>
                    </label>
                  </div>
                  <div className='u_inlineBlock izenda-PermissionCategory-group_left'>
                    <label>
                      <Input
                        type='checkbox'
                        readOnly={this.props.readOnly}
                        disabled={isTemplatePermissions}
                        checked={this.props.getCheckedCommon(this.tenantSetup.actions.edit)}
                        onChange={this.onChangeEdit}
                      />
                      <span>{localization.getText('COMMON_LABEL_EDIT')}</span>
                    </label>
                  </div>
                  <div className='u_inlineBlock izenda-PermissionCategory-group_left'>
                    <label>
                      <Input
                        type='checkbox'
                        readOnly={this.props.readOnly}
                        disabled={isTemplatePermissions}
                        checked={this.props.getCheckedCommon(this.tenantSetup.actions.del)}
                        onChange={this.onChangeDel}
                      />
                      <span>{localization.getText('COMMON_LABEL_DELETE')}</span>
                    </label>
                  </div>
                </GridLayout.Col>
                <GridLayout.Col cols={1} className='u_textCenter' />
              </GridLayout.Row>
              <GridLayout.Row className='u_paddingTop u_paddingBottom'>
                <GridLayout.Col cols={2} className='izenda-PermissionCategory-SubCategory'>
                  {localization.getText('PERMISSION_LABEL_PERMISSIONS')}
                </GridLayout.Col>
                <GridLayout.Col cols={9}>
                  <div className='u_inlineBlock izenda-PermissionCategory-group_left'>
                    <Input
                      type='checkbox'
                      checked={this.props.getCheckedCommon(this.tenantSetup.permissions.value)}
                      onChange={this.onChangePermission}
                      disabled={isTemplatePermissions}
                    />
                  </div>
                </GridLayout.Col>
                <GridLayout.Col cols={1} className='u_textCenter' />
              </GridLayout.Row>
            </GridLayout>
          )}
        </div>
      )
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/PermissionTab/PermissionBody/Izenda.PermissionTenantSetup.jsx